(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
     
    document.addEventListener("DOMContentLoaded", function() {
    let video = document.querySelector(".video-container video");
    let playButton = document.getElementById("playButton");
    let videoIsPlaying = document.querySelector('.video-is-playing');

    playButton.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        video.parentElement.classList.add("video-is-playing");
        playButton.style.display='none';
      } else {
        video.pause();
        video.parentElement.classList.remove("video-is-playing");
        playButton.style.display='block';
      }
    });
    if (video) {
            video.addEventListener('click', () => {
            video.pause();
            playButton.style.display='block';
            videoIsPlaying.classList.remove('video-is-playing');
        });
    }

    video.addEventListener("click", function() {
      video.pause();
      video.parentElement.classList.remove("video-is-playing");
    });

    video.addEventListener('ended', function() {
      video.parentElement.classList.remove("video-is-playing");
    }, false);
  });
    
  } catch(e) { console.error(e); }
})();
})();
